<p-dialog
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '30rem' }"
  [draggable]="false"
  [dismissableMask]="true"
  (onHide)="hideDialog()"
  (onShow)="showDialog2()"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      upload file
    </div>
  </ng-template>
  <stc-apps-file-upload-input 
    [isHidden]="isHidden"
    (uploadedFile)="getUploadedFile($event)"
    [fileType]="fileType"
  />
  <ng-template pTemplate="footer">
    <footer>
      <button class = "cancel-btn" (click)="visible = false;">cancel</button>
      <button 
        class = "import-data-btn" 
        (click)="importData()"
        [disabled]="!selectedFile"
        [class.disabled-btn]="!selectedFile"
      >import</button>
    </footer>
  </ng-template>
</p-dialog>